module.exports = __webpack_public_path__ + "img/unRateStarNoB.500a6edc.svg";